import {
  params,
  string as stringType,
  number as numberType,
  shape as shapeType,
  arrayOf as arrayType,
  id as idType,
  customType,
} from "@thd-nucleus/data-sources";

const dataModel = {
  paintOrderHistory: params({
    userId: idType().isRequired(),
    headers: customType("HeaderExtras").shape({
      tmxProfileId: stringType(),
      channelId: stringType(),
    }),
    request: customType("PaintOrderHistoryRequest!").shape({
      userId: stringType(),
      customerAccountId: stringType(),
      pageSize: numberType(),
      pageNumber: numberType(),
      filterKey: stringType(),
      filterValue: stringType(),
      sortBy: stringType(),
      sortOrder: stringType(),
      storeNumber: stringType(),
    }),
  }).shape({
    paginationInfo: shapeType({
      pageSize: numberType(),
      pageNumber: numberType(),
      totalPages: numberType(),
      totalNumberOfRecords: numberType(),
    }),
    paintOrderLineItems: arrayType(
      shapeType({
        mixDate: stringType(),
        paintType: stringType(),
        colorName: stringType(),
        colorId: stringType(),
        colorType: stringType(),
        brandName: stringType(),
        brandLogo: stringType(),
        quantity: numberType(),
        canSize: stringType(),
        sheenName: stringType(),
        formulaScaleValue: numberType(),
        vendorId: stringType(),
        competitiveVendorId: stringType(),
        rgb: shapeType({
          red: numberType(),
          green: numberType(),
          blue: numberType(),
        }),
        clickToAction: stringType(),
        clickToActionUrl: stringType(),
        surface: stringType(),
      }),
    ),
  }),
};

export default dataModel;
